import { getAppUrl } from "./appUrl";

const DEFAULT_OG_IMAGE = "/assets/images/logo/rghtnow-blue-logo.png";

const upsertMeta = (attribute, name, content) => {
  if (typeof document === "undefined" || !content) return;

  let element = document.head.querySelector(`meta[${attribute}="${name}"]`);

  if (!element) {
    element = document.createElement("meta");
    element.setAttribute(attribute, name);
    document.head.appendChild(element);
  }

  element.setAttribute("content", content);
};

const upsertCanonical = (href) => {
  if (typeof document === "undefined" || !href) return;

  let element = document.head.querySelector('link[rel="canonical"]');

  if (!element) {
    element = document.createElement("link");
    element.setAttribute("rel", "canonical");
    document.head.appendChild(element);
  }

  element.setAttribute("href", href);
};

export const setPageSeo = ({
  title,
  description,
  path = "",
  image = DEFAULT_OG_IMAGE,
}) => {
  if (typeof document === "undefined") return;

  const canonicalUrl = getAppUrl(path);
  const imageUrl = /^https?:\/\//i.test(image) ? image : getAppUrl(image);

  document.title = title;
  upsertMeta("name", "title", title);
  upsertMeta("name", "description", description);
  upsertCanonical(canonicalUrl);
  upsertMeta("property", "og:title", title);
  upsertMeta("property", "og:description", description);
  upsertMeta("property", "og:url", canonicalUrl);
  upsertMeta("property", "og:image", imageUrl);
  upsertMeta("property", "og:type", "website");
  upsertMeta("name", "twitter:card", "summary_large_image");
  upsertMeta("name", "twitter:title", title);
  upsertMeta("name", "twitter:description", description);
  upsertMeta("name", "twitter:image", imageUrl);
};
